import { useContext, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import Loader from "./Common/Loader";
import Layout from "./Shared/Layout";
import Banner from "./Shared/Banner";
import OurEminentSolutions from "./Shared/OurEminentSolutions";
import SmartDevelopment from "./Shared/SmartDevelopment";
import Video from "./Shared/Video";
import CollaborateWith from "./Shared/CollaborateWith";
import OurBlogsSection from "./Shared/OurBlogsSection";
import { ThemeContext } from "../Contaxt/ThemeContext";

const Home = () => {
    const { loaderDone, startExit, setIsSettled, hasLoadedOnce, setLasLoadedOnce } =
        useContext(ThemeContext);
    const { pathname } = useLocation();
    const showIntroLoader = pathname === "/";
    const homeReady = !showIntroLoader || loaderDone;

    useEffect(() => {
        if (!showIntroLoader) {
            document.body.style.overflow = "";
            document.documentElement.style.overflow = "";
            document.body.style.backgroundColor = "#fff";
            setIsSettled(true);
            return;
        }

        window.scrollTo(0, 0);
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
        document.body.style.backgroundColor = "#181818";

        return () => {
            document.body.style.overflow = "";
            document.documentElement.style.overflow = "";
        };
    }, [showIntroLoader, setIsSettled]);

    useEffect(() => {
        if (!showIntroLoader || !loaderDone) return;

        const settleTimer = setTimeout(() => {
            document.body.style.overflow = "auto";
            document.documentElement.style.overflow = "auto";
            document.body.style.backgroundColor = "#fff";
            setLasLoadedOnce(true);
            setIsSettled(true);
        }, 2200);

        return () => clearTimeout(settleTimer);
    }, [showIntroLoader, loaderDone, setIsSettled, setLasLoadedOnce]);

    return (
        <>
            <Helmet>
                <title>
                    iShivax — Custom Software, App & IoT Development | India & USA
                </title>
                <meta
                    name="description"
                    content="iShivax delivers AI, custom software, web applications, mobile apps, SaaS platforms, IoT solutions and cloud services worldwide."
                />
                <link rel="canonical" href="https://www.ishivax.com/" />
                <meta property="og:url" content="https://www.ishivax.com/" />
            </Helmet>

            {showIntroLoader && !loaderDone && <Loader />}

            <div
                className={`home-wrapper ${showIntroLoader && startExit && !hasLoadedOnce ? "reveal" : ""} ${homeReady ? "final" : ""}`}
            >
                <Layout>
                    <Banner />
                    <OurEminentSolutions />
                    <SmartDevelopment />
                    <Video />
                    <CollaborateWith />
                    <OurBlogsSection />
                </Layout>
            </div>
        </>
    );
};

export default Home;
